import { SecurityContextTemplate, SecurityContextCommonProps } from 'framework/authorization';
import { useServiceCatalogService } from 'domain/shared/serviceCatalog';

const ServiceCatalogContext = ({ permissionToCheck, children }: SecurityContextCommonProps) => {
  const { getServiceCatalogPermissions } = useServiceCatalogService() as any;

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getServiceCatalogPermissions}
      permissionToCheck={permissionToCheck}
      contextName="Service"
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default ServiceCatalogContext;
